import React from 'react';
import "./index.css";
import { boissons_items } from "./data/Plats"

const BoissonsAffichage = (props) => {

    return (
        <div id={props.id} className="menus-content">
            <h1>{props.nom}</h1>
            <div className="menus__inside">
                <ul className="ul_carte">
                    {
                        boissons_items[props.index].boissons.boisson?.map((i, index) => {
                            return <li key={index+"x"} ><span>{i}</span> <span className="dots"></span> <span className="carte_prix">{boissons_items[props.index].boissons.prix[index]}</span></li>
                        })
                    }

                    {boissons_items?.autres !== null ?
                        boissons_items[props.index].autres.map((i) => {
                            return (
                                <>
                                    <h2 key={i.titre}>{i.titre}</h2>
                                    {
                                        i.elements.map((si, index) => {
                                            return (
                                                <li key={si+index}><span>{si}</span> <span className="dots"></span> <span className="carte_prix">{i.prix[index]}</span></li>
                                            )
                                        })
                                    }
                                </>)
                        })
                        :
                        null
                    }
                </ul>
            </div>
        </div>
    );

};

export default BoissonsAffichage;